<div class="cards-wrapper">
  <div *ngFor="let user of newConnects" class="card">
    <div *ngIf="user.type == 'WC'">
      <div class="card-body">
        <img alt="image" class="img-circle" [src]="user.profile_photo" width="90">
        <div>
          <div class="cardname mb-1">
            <a>{{ user.name }}</a>
          </div>
          <div class="font-13">{{ user.description }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="user.type == 'BC'">
      <div class="card-body">
        <div>
          <div class="card-img">
            <img alt="image" class="img-circle comp-icon" [src]="user.comp_icon" width="90">
            <img alt="image" class="img-circle user-icon" [src]="user.profile_photo" width="90">
          </div>
        </div>
        <div>
          <div class="mb-1">{{ user.comp_name }}</div>
          <div class="cardname mb-1">
            <div>{{ user.name }}</div>
          </div>
          <div class="font-13">{{ user.description }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
